/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Petty_Flat_Buzzard_FlowInputs */

const fr_petty_flat_buzzard_flow = /** @type {(inputs: Petty_Flat_Buzzard_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton max de répétitions`)
};

/**

* @param {Petty_Flat_Buzzard_FlowInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const petty_flat_buzzard_flow = /** @type {((inputs?: Petty_Flat_Buzzard_FlowInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Petty_Flat_Buzzard_FlowInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_petty_flat_buzzard_flow(inputs)
});